import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";
import qs from 'qs';
export const cleanupAction = createAction('CLEANUP_SELECT_SURVEYS');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const getActivitySurveyRequest = createAction('SELECT_SURVEYS_GET_ACTIVITY_REQUEST');
export const getActivitySurveySuccess = createAction('SELECT_SURVEYS_GET_ACTIVITY_SUCCESS');
export const getActivitySurveyError = createAction('SELECT_SURVEYS_GET_ACTIVITY_ERROR');

export const getActivitySurvey = (id) => async (dispatch) => {
  try {
    dispatch(getActivitySurveyRequest());
    const resp = await instance.get(`/v1/ActivitySurvey/GetByActivityId/${id}`);
    
    dispatch(getActivitySurveySuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getActivitySurveyError(e.response.data.description));
    else
      dispatch(getActivitySurveyError(e.message));
  }
};

export const getSurveysRequest = createAction('SELECT_SURVEYS_GET_LIST_REQUEST');
export const getSurveysSuccess = createAction('SELECT_SURVEYS_GET_LIST_SUCCESS');
export const getSurveysError = createAction('SELECT_SURVEYS_GET_LIST_ERROR');

export const getSurveys = (libraryIds) => async (dispatch) => {
  try {
    dispatch(getSurveysRequest());
    const resp = await instance.get(`/v1/Survey/GetListByLibrary`, {
      params: {
        libraryIds
      },
      paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat'})
    });
    
    dispatch(getSurveysSuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getSurveysError(e.response.data.description));
    else
      dispatch(getSurveysError(e.message));
  }
};

export const confirmSurveysRequest = createAction('SELECT_SURVEYS_CONFIRM_REQUEST');
export const confirmSurveysSuccess = createAction('SELECT_SURVEYS_CONFIRM_SUCCESS');
export const confirmSurveysError = createAction('SELECT_SURVEYS_CONFIRM_ERROR');

export const confirmSurveys = (data) => async (dispatch) => {
  try {
    dispatch(confirmSurveysRequest());
    const resp = await instance.post(`/v1/ActivitySurvey/UpdateSurveyIds`, data);
    
    dispatch(confirmSurveysSuccess(resp.data.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(confirmSurveysError(e.response.data.description));
    else
      dispatch(confirmSurveysError(e.message));
  }
};